// src/window-api.js
export function exposeWindowAPI({ bootVenue, panels }) {
  window.AttraxionChat = window.AttraxionChat || {
    async open({ venue } = {}) {
      if (!venue) throw new Error('AttraxionChat.open: venue required');
      const entry = await bootVenue(venue);
      if (!entry) return; // silent bail — disabled/unknown venue
      entry.open();
    },
    close({ venue } = {}) {
      const e = panels.get(venue);
      e?.close();
    },
  };
}
